import { base64Url } from './nbInternationalSubsetBase64Url'
import { base64Url as boldBase64Url } from './nbInternationalSubsetBoldBase64Url'

export const nbInternationalFont = `
@font-face {
  font-family: 'NBInternationalProReg';
  font-style: normal;
  font-weight: 400;
  src: url(${base64Url}) format('woff2');
}
`

export const nbInternationalBoldFont = `
@font-face {
  font-family: 'NBInternationalProBol';
  font-style: normal;
  font-weight: 700;
  src: url(${boldBase64Url}) format('woff2');
}
`
